<b>MFA: </b>
<ng-container *ngIf="google || mobile; else noMfa">
  <b><u>Is</u></b> enabled for this user, of type:
  <span *ngIf="google"> Google Authenticator MFA</span>
  <span *ngIf="mobile"> SMS MFA</span>
  <div
    *ngIf="!(hasOnlyTrialDispenserRole$ | async)"
    class="btn btn-danger btn-sm button"
    (click)="removeMfaVerify.emit()"
  >
    <i class="fas fa-ban"></i> Remove MFA
  </div>
</ng-container>
<ng-template #noMfa>
  <span
    ><b><u>Is not</u></b></span
  >
  enabled for this user.
</ng-template>
